import { cn } from 'src/lib/tailwind-merge';
import { Typography } from '../Typography';
import type { CellTypes, TableBodyProps } from './type';
import { calculateColumnLeftPosition } from './util';
export const TableBody = ({ rows, fixedColumnCount }: TableBodyProps) => {
  const widthArray = rows.map((row) => row.map((cell) => cell.width));

  const getAlign = (cell: CellTypes) => {
    switch (cell.align) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
      default:
        return 'text-center';
    }
  };

  return (
    <tbody className="bg-white">
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {row.map((cell, cellIndex) => {
            const isFixedColumn = fixedColumnCount ? cellIndex < fixedColumnCount : false;
            const leftPosition = calculateColumnLeftPosition(cellIndex, widthArray[rowIndex]);

            return (
              <td
                key={cellIndex}
                className={cn(
                  'border-b border-gray-100 bg-white p-2 text-xs text-gray-900 [&:not(:last-child)]:border-r',
                  isFixedColumn && 'sticky',
                  getAlign(cell),
                )}
                style={
                  isFixedColumn ? { left: `${leftPosition}px`, width: `${cell.width}px` } : { width: `${cell.width}px` }
                }
              >
                <Typography
                  variant="caption3"
                  className="line-clamp-3 overflow-hidden text-ellipsis whitespace-pre text-[13px] font-normal text-gray-600"
                >
                  {cell.cellData}
                </Typography>
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
};
